export default __webpack_public_path__ + "static/media/breakfast_17.92e5ff9b.jpg";